export const DialogHideScroll = {
  data: () => ({
    HTMLElement: null,
  }),

  mounted() {
    this.HTMLElement = document.getElementsByTagName('html')[0];
  },

  watch: {
    async showPopup(value) {
      if (this.$store.state.dialog.iframeDialog !== null) value = true;
      await this.$nextTick();
      this.HTMLElement?.classList.toggle('hide-scroll', value);
    }
  },
};
